__turbopack_context__.v({
  "ReactModalPortal": "_style-module-scss-module__vaUmgq__ReactModalPortal",
  "ReactModal__Content__ReadyToClose": "_style-module-scss-module__vaUmgq__ReactModal__Content__ReadyToClose",
  "animateRight": "_style-module-scss-module__vaUmgq__animateRight",
  "animateRightMinus": "_style-module-scss-module__vaUmgq__animateRightMinus",
  "animateTop": "_style-module-scss-module__vaUmgq__animateTop",
  "animateTopMinus": "_style-module-scss-module__vaUmgq__animateTopMinus",
  "backdrop-position__right": "_style-module-scss-module__vaUmgq__backdrop-position__right",
  "component__tabs__wrapper": "_style-module-scss-module__vaUmgq__component__tabs__wrapper",
  "dialog-content-position__center": "_style-module-scss-module__vaUmgq__dialog-content-position__center",
  "dialog-content-position__right": "_style-module-scss-module__vaUmgq__dialog-content-position__right",
  "dialog__content": "_style-module-scss-module__vaUmgq__dialog__content",
  "primary-layout__context": "_style-module-scss-module__vaUmgq__primary-layout__context",
  "tabs-nav": "_style-module-scss-module__vaUmgq__tabs-nav",
});
